// Filters
export interface Filter {
  name: string;
  property: FilterCategoryEndpointProperty;
  active: boolean;
}

export class FilterCategory {
  name: FilterCategoryName;
  property: FilterCategoryEndpointProperty;
  filters: Filter[];
}

export type FilterCategoryName =
  | 'Flavour'
  | 'Type'
  | 'Process'
  | 'Origin'
  | 'Varietal'
  | 'Roast';

export type FilterCategoryEndpointProperty =
  | 'flavourProfile'
  | 'type'
  | 'process'
  | 'origin'
  | 'varietal'
  | 'roast';

// Sort
export type SortBy =
  | 'Alphabetically, A-Z'
  | 'Alphabetically, Z-A'
  | 'Price, low to high'
  | 'Price, high to low'
  | 'Date, old to new'
  | 'Date, new to old';

export const SortByValues: SortBy[] = [
  'Alphabetically, A-Z',
  'Alphabetically, Z-A',
  'Price, low to high',
  'Price, high to low',
  'Date, old to new',
  'Date, new to old',
];

// Product
export interface Product {
  handle: string;
  id: string;
  productType: string;
  featuredImage: string;
  featuredImageAlt: string;
  title: string;
  farmName: string;
  flavourProfile: string;
  flavourNotes: string;
  process: string;
  varietal: string;
  roast: string;
  type: string;
  origin: string;
  price: number;
  price_varies: boolean;
  dateAdded: Date;
  featured: boolean;
  bestselling: boolean;
  options: ProductOptions[];
  variants: Variant[];
}

export interface ProductOptions {
  name: string;
  values: string[];
  selectedValue: string;
}

export interface Variant {
  id: string;
  availableForSale: boolean;
  price: number;
  selectedOptions: SelectedOptions[];
}

export interface SelectedOptions {
  name: string;
  values: string;
}

// Blocks
export interface ContentBlock {
  position: number;
  overlay_text: string;
  link_text: string;
  link_url: string;
  background_colour: string;
}
